import { render, staticRenderFns } from "./parents.vue?vue&type=template&id=f7ec3794&"
import script from "./parents.vue?vue&type=script&lang=js&"
export * from "./parents.vue?vue&type=script&lang=js&"
import style0 from "./parents.vue?vue&type=style&index=0&id=f7ec3794&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports